/* global Foundation */
const HeaderBase = require('./header-base');

$(document).ready(function() {
  Foundation.MediaQuery._init();
  let header = new HeaderBase(Foundation);
  header.init();
});
